import { errorMessage } from '@elara/core/errors';
import { shorten } from '@elara/core/utils';

import { firstLine } from '#lib/utils.js';

export function formatShortToolError(err: unknown, { maxLength = 64 } = {}): string {
  const text = errorMessage(err, { fallbackMessage: 'Unknown error' });
  const cleanedUpText = cleanUpErrorMessage(text);
  return shorten(firstLine(cleanedUpText), { maxLength });
}

export function cleanUpErrorMessage(message: string): string {
  const match = message.match(/^[^\n\{\[]+/);
  if (match) message = match[0].trim().replaceAll(/\s*[:,;-]\s*$/g, '');
  message ||= 'Unknown error';
  return message;
}
